import { render } from "./SystemTriggers.vue?vue&type=template&id=200a6674&scoped=true&lang=pug"
import script from "./SystemTriggers.js?vue&type=script&lang=js&external"
export * from "./SystemTriggers.js?vue&type=script&lang=js&external"

import "./SystemTriggers.vue?vue&type=style&index=0&id=200a6674&lang=scss&scoped=true"
import "./SystemTriggers.vue?vue&type=style&index=1&id=200a6674&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200a6674"]])

export default __exports__